import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { useOBMutation } from './useOBMutation';

interface ConfirmAppointmentProps {
  appointmentId: string | null;
  patientId?: string;
}

const useConfirmAppointment = ({
  appointmentId,
  patientId,
}: ConfirmAppointmentProps) => {
  const url = useApiUrl(
    OBRoutes.AppointmentConfirm,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )
    ?.replace('##appointmentId', appointmentId ?? '')
    ?.concat(`?patientId=${patientId}`);

  return useOBMutation(url || '', {});
};

export default useConfirmAppointment;
